import { ButtonLink } from '@designsforhealth/dfh-react-components'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import withClickWrapModalContextProvider from '../../../../hoc/withClickWrapModalContextProvider'
import useLegalAgreements from '../../../../hooks/useLegalAgreements'
import { displayNameForAgreementId } from '../../../../utils/legalAgreements'
import { ClickWrapModalContext } from '../../../global/clickwrap/context'
import ViewAcceptedAgreement from './ViewAcceptedAgreement'

interface AcceptedAgreementsProps {
  className?: string
}

const AcceptedAgreements: React.FC<AcceptedAgreementsProps> = ({ className }) => {
  const { accepted } = useLegalAgreements()
  const agreementsArray = useMemo(() => Object.entries(accepted), [accepted])
  const [modalState] = useContext(ClickWrapModalContext)
  const [viewAgreementId, setViewAgreementId] = useState('')

  useEffect(() => {
    if (!modalState.isOpen) {
      setViewAgreementId('')
    }
  }, [modalState.isOpen])

  return (
    <section className={className}>
      <header className="section-header">
        <h3>Accepted Agreements</h3>
      </header>
      <div className="section-body">
        <table>
          <thead>
            <tr>
              <th>Agreement</th>
              <th>Accepted At</th>
            </tr>
          </thead>
          <tbody>
            {agreementsArray.length > 0 &&
              agreementsArray.map(([agreementId, acceptedAt]) => (
                <tr key={agreementId}>
                  <td>
                    <ButtonLink
                      text={displayNameForAgreementId(agreementId)}
                      onClick={() => setViewAgreementId(agreementId)}
                    />
                  </td>
                  <td>{acceptedAt}</td>
                </tr>
              ))}
            {agreementsArray.length === 0 && (
              <tr>
                <td colSpan={2}>None found</td>
              </tr>
            )}
          </tbody>
        </table>
        <ViewAcceptedAgreement agreementId={viewAgreementId} />
      </div>
    </section>
  )
}

const StyledAcceptedAgreements = styled(AcceptedAgreements)(({ theme }) => ({
  marginBottom: '17px',
  '.section-header': {
    marginBottom: '1em',
  },
  '.section-body': {
    backgroundColor: theme.colors.grayscale.white,
    borderRadius: '4px',
    padding: '24px',
    lineHeight: '1.5',
  },
  table: {
    width: '100%',
  },
  'th ~ th, td ~ td': {
    paddingLeft: '20px',
  },
  th: {
    textAlign: 'left',
    fontWeight: 'bold',
  },
  [ButtonLink]: {
    textDecoration: 'underline',
  },
}))

// wrap with separate modal context provider to isolate display of
// accepted agreements from pending agreements
export default withClickWrapModalContextProvider(StyledAcceptedAgreements)
